


































































import Vue from "vue";

export default Vue.extend({
  computed: {
    copyrightText(): string {
      const currentYear = String(new Date().getFullYear());
      const translated = String(this.$t("footer.copyright"));

      return translated.replace(/\b\d{4}\b/, currentYear);
    }
  }
});
